function cov_129ht72853() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/AvatarFilled.tsx";
  var hash = "9b4a5271fcfb7a08c3d91d51da5a3760a8f26f22";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/AvatarFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9b4a5271fcfb7a08c3d91d51da5a3760a8f26f22"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_129ht72853 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_129ht72853();
var Icon = (cov_129ht72853().s[0]++, {
  name: 'avatar-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.0001 7C17.0001 9.76142 14.7615 12 12.0001 12C9.23867 12 7.00009 9.76142 7.00009 7C7.00009 4.23858 9.23867 2 12.0001 2C14.7615 2 17.0001 4.23858 17.0001 7ZM9.53051 13C7.35151 13 5.34378 14.1814 4.28556 16.0861L2.6508 19.0287C1.91021 20.3618 2.87415 22 4.39912 22H19.6011C21.126 22 22.09 20.3618 21.3494 19.0287L19.7146 16.0861C18.6564 14.1814 16.6487 13 14.4697 13H9.53051Z\" fill=\"currentColor\"/>"
});
export default Icon;